import { requester } from '../utils';

export const getCafes = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getAmenities = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/amenity`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getSpecialServices = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/specialService`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const insertNewCafe = cafeObject => {
  return new Promise((resolve, reject) => {
    console.log('caefe', cafeObject);
    requester
      .fetchAPI({
        route: `v1/cafe`,
        method: 'POST',
        data: cafeObject,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getCafeById = cafeId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/${cafeId}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafe = cafeObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe`,
        method: 'PUT',
        data: cafeObject,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchSearchedCafeUser = search => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe`,
        method: 'PUT',
        data: cafeObject,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const changeCafeStatus = (cafeId, status) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/cafe/status',
        method: 'PUT',
        data: {
          cafeId,
          status,
        },
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteCafeUser = userId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/user/${userId}`,
        method: 'DELETE',
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCafeUserDetails = userId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/user/${userId}`,
        method: 'GET',
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafeUser = (userId, roleId) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/user`,
        method: 'PUT',
        data: {
          userId,
          roleId,
        },
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getCafeByIdForAdmin = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/cafe-admin`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafeImagesAndLogoForAdmin = imagesAndLogoObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/cafe-admin`,
        method: 'PUT',
        data: imagesAndLogoObject,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCafeDiscountDetailsById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getAllCafeNamesForPanel = cityCode => {
  return new Promise((resolve, reject) => {
    cityCode
      ? requester
          .fetchAPI({
            route: `v1/cafe/names-for-panel?cityCode=${cityCode}`,
            method: 'GET',
            withAuth: true,
          })
          .then(result => {
            resolve(result.payload);
          })
          .catch(err => {
            reject(err);
          })
      : requester
          .fetchAPI({
            route: `v1/cafe/names-for-panel`,
            method: 'GET',
            withAuth: true,
          })
          .then(result => {
            resolve(result.payload);
          })
          .catch(err => {
            reject(err);
          });
  });
};

export const getAllCafeContract = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-contract/cafes`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getCafesExcelFile = query => {
  return new Promise((resolve, reject) => {
    requester
      .getFileFromAPI({
        route: 'v1/cafe/excel?' + query,
        contentType: 'application/octet-stream',
      })
      .then(res => {
        var filename = decodeURI(
          res.headers['content-disposition'].split('filename=')[1],
        );
        var blob = new Blob([res.data], { type: 'application/octet-stream' });
        resolve({ filename, blob });
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getRegions = (id, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/byCityId/${id}?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch region list error', err);
        reject(err);
      });
  });
};
